let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3sgh6")).then(() => parcelRequire('aWykd'));